/* Roasterland coffee profile: seeded by the coffee finder, learns from purchases and ratings.
   v1 keeps the profile in the browser (localStorage); signed-in accounts will sync it to
   customer metafields (custom.coffee_profile) once the Roasterland app is in place. */
(function () {
  'use strict';
  var KEY = 'rl_profile_v1';
  var FLAV = ['fruit', 'floral', 'citrus', 'choc', 'sweet', 'spice'];
  var ROAST = { 'Light': 1, 'Medium-light': 2, 'Medium': 3, 'Medium-dark': 4, 'Dark': 5 };
  var KEYS = {
    fruit: /berr|cherry|peach|plum|apricot|grape|strawberr|raspberr|blueberr|fruit|jam|mango|pineapple|tropical|wine|fig|raisin|date/i,
    floral: /floral|jasmine|bergamot|rose|lavender|hibiscus|tea|honeysuckle|orange blossom|elderflower/i,
    citrus: /citrus|lemon|lime|orange|grapefruit|tangerine|mandarin|bright|zest/i,
    choc: /choc|cocoa|cacao|nut|almond|hazelnut|walnut|pecan|peanut|praline/i,
    sweet: /caramel|sugar|honey|toffee|molasses|syrup|vanilla|butterscotch|maple|marshmallow|candy|sweet/i,
    spice: /spice|earthy|cedar|clove|cinnamon|tobacco|herbal|pepper|smok|wood|leather|savory|cardamom/i
  };
  var PROC = { fruit: ['Natural', 'Anaerobic', 'Experimental'], floral: ['Washed'], citrus: ['Washed'], choc: [], sweet: ['Honey'], spice: ['Wet-hulled'] };
  var LR = 0.25, HALF_LIFE_DAYS = 120;

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; } }
  function save(p) { p.updated = Date.now(); try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {} return p; }
  function blank() {
    var f = {}; FLAV.forEach(function (k) { f[k] = 0.4; });
    return { v: 1, roast: 3, adventure: 3, flavors: f, process: {}, cupMax: 250, brew: '', milk: '', confidence: 0, tasted: {}, loved: {}, disliked: {}, roasters: {}, seen: {}, locked: {}, created: Date.now() };
  }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }

  // What a coffee "is", on the profile's dimensions
  function traits(c) {
    var f = {};
    FLAV.forEach(function (k) { f[k] = KEYS[k].test(c.n || '') ? 1 : (PROC[k].indexOf(c.pr) > -1 ? 0.6 : 0); });
    return { roast: ROAST[c.ro] || 3, adventure: c.a || 2, flavors: f, process: c.pr || '', cup: c.g ? Math.round(c.p * 15 / c.g) : 0 };
  }

  var R = {
    get: load,
    exists: function () { var p = load(); return !!(p && p.confidence > 0); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} },

    // Seed from the coffee finder answers: {brew, milk, flavors[], adv, budget}
    seed: function (a) {
      var p = load() || blank();
      var roast = { pour: 1.6, drip: 2.8, espresso: 3.6, press: 3.4, cold: 3.8, any: 2.8 }[a.brew] || 2.8;
      if (a.milk === 'milk') roast += 0.8;
      if (a.roast) roast = a.roast;
      if (!p.locked.roast) p.roast = clamp(roast, 1, 5);
      if (!p.locked.adventure) p.adventure = a.adv || 3;
      if (!p.locked.flavors) FLAV.forEach(function (k) { p.flavors[k] = (a.flavors || []).indexOf(k) > -1 ? 0.9 : 0.25; });
      p.cupMax = { 20: 120, 30: 200, 999: 400 }[a.budget] || 250;
      p.brew = a.brew; p.milk = a.milk;
      if (a.ritual) p.ritual = a.ritual;
      p.confidence = Math.max(p.confidence, 0.3);
      p.quiz = { at: Date.now(), answers: a };
      return save(p);
    },

    // Learn from one event. weight: loved +1, swapped in +0.6, bought +0.5, good +0.4,
    // kept delivery +0.3, skipped -0.2, swapped out -0.4, not for me -0.8, cancelled for taste -1
    learn: function (c, weight, id) {
      var p = load() || blank();
      if (id) { if (p.seen[id]) return p; p.seen[id] = Date.now(); }
      var t = traits(c), w = LR * weight;
      if (!p.locked.roast) p.roast = clamp(p.roast + w * (t.roast - p.roast), 1, 5);
      if (!p.locked.adventure) p.adventure = clamp(p.adventure + w * (t.adventure - p.adventure), 1, 5);
      var knowsFlavor = FLAV.some(function (k) { return t.flavors[k] > 0; });
      if (!p.locked.flavors && knowsFlavor) FLAV.forEach(function (k) { p.flavors[k] = clamp(p.flavors[k] + w * (t.flavors[k] - p.flavors[k]), 0, 1); });
      if (t.process) p.process[t.process] = clamp((p.process[t.process] || 0) + weight * 0.2, -1, 1);
      if (weight > 0 && t.cup) p.cupMax = Math.max(p.cupMax, Math.round(t.cup * 1.1));
      if (c.o) { if (weight > 0) p.tasted[c.o] = p.tasted[c.o] || Date.now(); }
      if (c.u) { if (weight >= 1) p.loved[c.u] = 1; if (weight <= -0.8) p.disliked[c.u] = 1; }
      if (c.r && weight >= 0.6) p.roasters[c.r] = (p.roasters[c.r] || 0) + 1;
      p.confidence = clamp(p.confidence + Math.abs(weight) * 0.1, 0, 1);
      return save(p);
    },

    // 0–100 match plus human reasons
    score: function (c, p) {
      p = p || load();
      if (!p) return { s: 0, why: [] };
      if (p.disliked[c.u]) return { s: 0, why: ['You marked this “not for me”'] };
      var t = traits(c), why = [];
      var liked = FLAV.filter(function (k) { return p.flavors[k] >= 0.6; });
      var hits = liked.filter(function (k) { return t.flavors[k] >= 0.6; });
      var flav = liked.length ? hits.length / liked.length : 0.5;
      if (c.n && hits.some(function (k) { return KEYS[k].test(c.n); })) why.push('Notes of ' + c.n.toLowerCase().split(/[,·]/)[0].trim());
      var roast = 1 - Math.min(1, Math.abs(t.roast - p.roast) / 4);
      if (roast > 0.8 && c.ro) why.push(c.ro + ' roast, your sweet spot');
      var adv = 1 - Math.min(1, Math.abs(t.adventure - p.adventure) / 3);
      if (adv > 0.9) why.push('Adventure ' + t.adventure + '/5, like you');
      var price = !t.cup || t.cup <= p.cupMax ? 1 : Math.max(0, 1 - (t.cup - p.cupMax) / 150);
      var s = flav * 38 + roast * 26 + adv * 24 + price * 12;
      if (c.o && !p.tasted[c.o]) { s += 3; if (c.rare) why.push('A new stamp for your passport'); }
      if (c.r && p.roasters[c.r]) { s += 2; why.push('From a roaster you love'); }
      var procPref = p.process[t.process] || 0; s += procPref * 4;
      if (c.o && p.tasted[c.o] && Date.now() - p.tasted[c.o] < 60 * 864e5) s -= 10;
      return { s: Math.round(clamp(s, 0, 99)), why: why };
    },

    rank: function (list, opts) {
      var p = load(); opts = opts || {};
      return list.map(function (c) { var r = R.score(c, p); return { c: c, s: r.s, why: r.why }; })
        .filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s; });
    },

    // Signed-in customers: purchases from their order history teach the profile once each
    syncOrders: function (lines) {
      (lines || []).forEach(function (l) { R.learn(l, 0.5, 'o' + l.order + '-' + l.u); });
    },

    decay: function () {
      var p = load(); if (!p) return;
      var days = (Date.now() - (p.updated || Date.now())) / 864e5;
      if (days < 7) return;
      p.confidence = p.confidence * Math.pow(0.5, days / HALF_LIFE_DAYS);
      save(p);
    }
  };
  window.RLProfile = R;
  R.decay();
})();
